var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS4CallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9431 3.38556L13.1195 5.49338C14.181 7.39557 13.7549 9.89091 12.0829 11.5629C12.0829 11.5629 10.055 13.5911 13.7319 17.2681C17.4077 20.9439 19.4371 18.9171 19.4371 18.9171C21.1091 17.2451 23.6044 16.819 25.5066 17.8806L27.6144 19.0569C30.4868 20.6599 30.8259 24.688 28.3013 27.2128C26.7842 28.7299 24.9257 29.9103 22.8712 29.9881C19.4128 30.1193 13.5394 29.2441 7.64771 23.3523C1.75605 17.4606 0.880759 11.5872 1.01188 8.12874C1.08976 6.07429 2.2702 4.2158 3.78728 2.69873C6.312 0.174006 10.3401 0.513234 11.9431 3.38556Z",
    stroke: "#F37A50",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4CallIcon);
export default __webpack_public_path__ + "static/media/s4-call-icon.ae02b50010619dffe70131e4ec30ee57.svg";
export { ForwardRef as ReactComponent };